export default __webpack_public_path__ + "static/media/HowNotArrested.508392d5.pdf";